import React, { useState } from 'react';
import { X } from 'lucide-react';
import axios from 'axios';
import { apiUrl } from "../../config/Config";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';

const UploadImageModal = ({ isOpen, onClose, onSave }) => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [showLoading, setShowLoading] = useState(false);

  // Input field states
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  // Keeping default role as 'Admin' as it's still a valid option
  const [role, setRole] = useState('Admin'); 
  const [password, setPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');

  const [image, setimage] = useState(null);

  // Updated roles: removed 'Super'
  const roles = ['Admin', 'Superadmin'];


const handleSave = async () => {
      setShowLoading(true);
      var data = {
        image: image
    };
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "createnewimage", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            onSave();
            onClose();
            setShowLoading(false);
          } else {
            if(res.data.message == "invalid user") {
              dispatch({ type: "userdata", payload: {} })
              navigate('/admin/login');
            } else {
                alert(res.data.message);
            }
            setShowLoading(false);
          }
        })
        .catch((err) => {
          setShowLoading(false);
          alert(err.message);
        });
      setShowLoading(false);
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const handleinputchange = async (file) => {
    //   var obj = {};
    // await getBase64(file).then((result) => {
    //   obj["name"] = file.name;
    //   obj["image"] = result;
    // });
    // // console.log('obj >>', obj);
    // setimage(obj);

    console.log('file >>', file);
    var imagesarr = [];
    for(var i = 0; i < file.length; i++) {
      var obj = {};
      await getBase64(file[i]).then(result => {
          // console.log('result ...', result);
          // base64_decode($base64encodedstring)
          obj['name'] = file[i].name;
          obj['image'] = result;
      });
      imagesarr.push(obj);
  }
  setimage(imagesarr);
  console.log('imagesarr >>', imagesarr);
    
  };

  if (!isOpen) return null;

  return (
    <div className="user-modal-overlay">
      <div className="user-modal-container">
        <div className="user-modal-header">
          <h2 className="createpost-modal-title">Upload New Image</h2>
          <button onClick={onClose} className="user-modal-close-btn">
            <X size={20} />
          </button>
        </div>

        <div className="user-modal-form">
          <div className="">
            <div className="user-modal-field">
              <label>Upload</label>
              <input
                onChange={(t) => {
                    handleinputchange(t.target.files);
                  }}
                  accept="image/*"
                  multiple
                  type="file"
                required
              />
            </div>
            <div className="user-modal-footer mt-3">
                <button type="submit" className="user-modal-submit" onClick={handleSave} disabled={showLoading}>
                    {showLoading ? 'Uploading...' : 'Submit'}
                </button>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadImageModal;